import { useState } from "react";

/**
 * True when this document is running inside a nested browsing context (iframe).
 * Evaludated in Layout.js to hide footer and some header items when true.
 * Used for Gateway 2.0 which iframes this UI 
 */
export function isEmbeddedFrame() {
  if (typeof window === "undefined") {
    return false;
  }
  try {
    return window.self !== window.top;
  } catch {
    /* cross-origin edge cases, window.top may error */
    return true;
  }
}

export function useEmbeddedView() {
  const [embedded] = useState(() => isEmbeddedFrame());
  return embedded;
}
